// Page identification can abbreviate; the full form title remains in the
// clinical document. Fit by actual font metrics, not character count.
export function fitPdfIdentification(pdf, value, width, maxLines = 2) {
    const lines = pdf.splitTextToSize(String(value || ''), width);
    if (lines.length <= maxLines) return lines;
    const fitted = lines.slice(0, maxLines);
    let last = fitted[maxLines - 1];
    while (last && pdf.splitTextToSize(`${last}...`, width).length > 1) last = last.slice(0, -1);
    fitted[maxLines - 1] = `${last}...`;
    return fitted;
}
